"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSelectedConsolidatedMids = exports.setSelectedConsolidatedMids = exports.getSelectedConsolidatedMids = exports.isConsolidatedDashboard = exports.isConsolidatedDashboardEnabled = exports.getConsolidatedUsersDetails = void 0;

var _localStorage = _interopRequireDefault(require("local-storage"));

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _merchantSession = require("./merchantSession");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _getSessionCookies = (0, _merchantSession.getSessionCookies)(),
    merchantMID = _getSessionCookies.merchantMID;

var cookie = new _universalCookie["default"]();

var getConsolidatedUsersDetails = function getConsolidatedUsersDetails() {
  try {
    var consolidated_product_accounts = (0, _localStorage["default"])("consolidated_product_accounts");

    if (consolidated_product_accounts) {
      return consolidated_product_accounts || [];
    }

    return [];
  } catch (e) {
    console.error("Consolidate Dashobard Error", e);
    return [];
  }
};

exports.getConsolidatedUsersDetails = getConsolidatedUsersDetails;
var isConsolidatedDashboardEnabled = cookie.get('acl_role_name') === 'Consolidated Dashboard';
exports.isConsolidatedDashboardEnabled = isConsolidatedDashboardEnabled;
var isConsolidatedDashboard = isConsolidatedDashboardEnabled && getConsolidatedUsersDetails().length > 0;
exports.isConsolidatedDashboard = isConsolidatedDashboard;

var getSelectedConsolidatedMids = function getSelectedConsolidatedMids() {
  var uniqueId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : merchantMID;
  var mids = (0, _localStorage["default"])("".concat(uniqueId, "-selectedMids"));

  if (Array.isArray(mids) && mids.length > 0) {
    try {
      return mids;
    } catch (e) {
      console.error("Consolidate Dashobard Error for get mid", e);
      return [];
    }
  }

  return getConsolidatedUsersDetails().map(function (u) {
    return u.identifier;
  });
};

exports.getSelectedConsolidatedMids = getSelectedConsolidatedMids;

var setSelectedConsolidatedMids = function setSelectedConsolidatedMids(selectedMids) {
  var uniqueId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : merchantMID;
  (0, _localStorage["default"])("".concat(uniqueId, "-selectedMids"), selectedMids);
};

exports.setSelectedConsolidatedMids = setSelectedConsolidatedMids;

var clearSelectedConsolidatedMids = function clearSelectedConsolidatedMids() {
  var uniqueId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : merchantMID;

  _localStorage["default"].remove("".concat(uniqueId, "-selectedMids"));
};

exports.clearSelectedConsolidatedMids = clearSelectedConsolidatedMids;